import { useQuery } from "@tanstack/react-query";
import { getCalendarEvents } from "@/lib/api";
import type { CalEvent } from "./types";

/**
 * Thin fetch hook shared by /calendar and the pop-out inbox's Calendar
 * module. `start`/`end` are ISO strings (own-calendar-only endpoint unless
 * targetEmail is passed for a manager/admin viewing someone else's).
 */
export function useCalendarEvents(start: string, end: string, targetEmail?: string) {
  const { data, isLoading, isError } = useQuery({
    queryKey: ["calendar-events", start, end, targetEmail ?? "self"],
    queryFn: () => getCalendarEvents(start, end, targetEmail),
    staleTime: 5 * 60 * 1000,
  });

  const events: CalEvent[] = data?.events ?? [];
  const configured = data?.configured !== false; // treat undefined (loading) as true

  return { events, configured, isLoading, isError };
}
